// RPECK 09/05/2023
// System to give us the means to manage the delivery options widget via JS
class DeliveryOption extends HTMLElement {
  constructor() {
    super();

    // Shadow Root
    // This is used to give us the means to add a flag icon next to the text
    this.attachShadow({mode: 'open'}).innerHTML = '<slot></slot>';

    // Time
    this.today = new Date();
    this.time  = this.today.getHours() + ":" + this.today.getMinutes() + ":" + this.today.getSeconds();

    // Countries List
    // This is a list of countries and their delivery time requirements 
    this.countries_list = [
      {
        "before_1350": {
          "min": 1,
          "max": 2
        },
        "after_1350": {
          "min": 2,
          "max": 3       
        },
        "countries": ["DE"]
      },
      {
        "before_1350": {
          "min": 2,
          "max": 3
        },
        "after_1350": {
          "min": 3,
          "max": 4       
        },
        "countries": ["AT", "BE", "LU", "NL", "CH"]
      },
      {
        "before_1350": {
          "min": 2,
          "max": 4
        },
        "after_1350": {
          "min": 3,
          "max": 5       
        },
        "countries": ["IE", "PL", "SK", "GB"]
      },
      {
        "before_1350": {
          "min": 3,
          "max": 5
        },
        "after_1350": {
          "min": 4,
          "max": 6       
        },
        "countries": ["HR", "CZ", "FR", "HU", "IT", "LV", "LT", "PT", "SI", "SE"]
      },
      {
        "before_1350": {
          "min": 3,
          "max": 7
        },
        "after_1350": {
          "min": 4,
          "max": 8       
        },
        "countries": ["BG", "EE", "RO"]
      }, 
      {
        "before_1350": {
          "min": 4,
          "max": 7
        },
        "after_1350": {
          "min": 5,
          "max": 8       
        },
        "countries": ["FI", "ES"]
      },
      {
        "before_1350": {
          "min": 2,
          "max": 4
        },
        "after_1350": {
          "min": 3,
          "max": 5       
        },
        "countries": ["IE", "PL", "SK", "GB"]
      }
    ];

    // Vars for the different days etc
    var day  = this.today.getDay();
    var hour = this.today.getHours();
    var min  = this.today.getMinutes();

    // Check if the hour is before 13:50 or after
    this.before_1350 = (hour <= 14) ? "before_1350" : "after_1350";

  }

  // Connected Callback
  connectedCallback() {

    // Vars
    var _this         = this;
    this.locale       = this.getAttribute("data-locale"); // language
    this.localization = this.getAttribute("data-localization"); //country
    
    // Stylesheet
    const linkElem = document.createElement("link");
    linkElem.setAttribute("rel", "stylesheet");
    linkElem.setAttribute("href", "https://cdn.jsdelivr.net/gh/lipis/flag-icons@6.6.6/css/flag-icons.min.css");

    // Template
    const template = document.createElement('template');

    // Div
    const flag_div = document.createElement('div');
    flag_div.classList.add('fi');
    flag_div.classList.add('fi-' + this.locale);
    flag_div.style.marginRight = "5px";

    // Add Template to ShadowRoot
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.shadowRoot.appendChild(linkElem);
    this.shadowRoot.prepend(flag_div);

    // Settings
    this.classList.add('delivery_options');

    // Get country
    var country = this.countries_list.filter(function(e){
        return e.countries.includes(_this.locale.toUpperCase());
    });

    // Default country
    if(!country) country = "DE";

    // Get data
    let {min, max} = country[0][this.before_1350];

    // New Dates
    var today_min = new Date(this.today);
    var today_max = new Date(this.today);
    
    // Timestamps
    var min_delivery_timestamp = today_min.setDate(this.today.getDate() + min);
    var max_delivery_timestamp = today_max.setDate(this.today.getDate() + max);

    // Difference
    var now = Date.now();

    // Dates
    var min_date = new Date(min_delivery_timestamp).setHours(0,0,0,0);
    var max_date = new Date(max_delivery_timestamp).setHours(0,0,0,0);

    // Properties
    this.min_delivery_date  = new Date(min_delivery_timestamp).getDate();
    this.max_delivery_date  = new Date(max_delivery_timestamp).getDate();
    this.month              = new Date(min_delivery_timestamp).toLocaleString(this.locale + '-' + this.localization, { month: 'long' });

    // Calculate time left
    // https://www.educative.io/answers/how-to-create-a-countdown-timer-using-javascript
    var timeleft = min_date - this.today.getTime();
    
    this.days_left      = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    this.hours_left     = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.mins_left      = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds_left   = Math.floor((timeleft % (1000 * 60)) / 1000);

    // Start Timer
    setInterval(function () {

      // Get the new mins-left
      var mins_left = parseInt(_this.mins_left) - 1;

      // Minutes
      if(mins_left <= 0) {
        _this.mins_left = 59;
        _this.hours_left = parseInt(_this.hours_left) - 1;
      } else {
        _this.mins_left = mins_left;
      }
    
    }, 60000);
    
  }

  dateDiffInDays(a, b) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  // Observed Attributes
  // Gives us a way to hook into the system in a more refined way
  static get observedAttributes() {
    return ["mins_left"];
  }

  // Attribute changes
  // More succinct to hook into API than creating the code manually
  attributeChangedCallback(name, oldValue, newValue) { 

    // Template
    var text = this.countries_text;

    // Replace
    text = text.replace("%%min%%",          this.min_delivery_date);
    text = text.replace("%%max%%",          this.max_delivery_date);
    text = text.replace("%%month%%",        this.month);
    text = text.replace("%%minutes_left%%", this.mins_left);
    text = text.replace("%%hours_left%%",   this.hours_left);

    // Output 
    this.textContent = text;
    
  }
  
  ////////////////
  // Properties //
  ////////////////

  // Min Date
  set min_delivery_date(value) { this._min_delivery_date = value; }
  get min_delivery_date()      { return this._min_delivery_date; }   

  // Max Date
  set max_delivery_date(value) { this._max_delivery_date = value; }
  get max_delivery_date()      { return this._max_delivery_date; }    

  // Month
  set month(value) { this._month = value; }
  get month()      { return this._month; }   

  // Hours Left
  set hours_left(value) { this._hours_left = value; this.setAttribute('hours_left', value); }
  get hours_left()      { return this._hours_left; }  

  // Mins Left
  set mins_left(value) { this._mins_left = value; this.setAttribute('mins_left', value); }
  get mins_left()      { return this._mins_left; }  

  // Locale
  set locale(value) { this._locale = value; }
  get locale()      { return this._locale; }  

  // Countries
  // This is used to give us the means to identify the text required for reach language/locality
  get countries_text()    { 
    return "Lieferung %%min%%. bis %%max%%. %%month%% bei Bestellung innerhalb von %%hours_left%% Std. %%minutes_left%% Min.";
  }
  
}

customElements.define("delivery-options", DeliveryOption);